module.exports = __webpack_public_path__ + "milestone.svg";